import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowDownRight } from 'lucide-react';
import { Marquee } from './Marquee';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.76, 0, 0.24, 1]
      }
    }
  };
  return <section className="pt-32 pb-16 md:pt-48 md:pb-24 min-h-[90vh] flex flex-col justify-between" data-id="element-119">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full flex-grow flex flex-col justify-center" data-id="element-120">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="max-w-5xl" data-id="element-121">
          <motion.p variants={itemVariants} className="text-accent font-medium tracking-wide uppercase text-sm mb-6" data-id="element-122">
            Independent Graphic Designer
          </motion.p>

          <motion.h1 variants={itemVariants} className="text-6xl md:text-8xl lg:text-[8.5rem] leading-[0.95] font-serif font-bold tracking-tight text-ink mb-8" data-id="element-123">
            Crafting visual <br data-id="element-124" />
            <span className="italic text-ink-light" data-id="element-125">narratives</span> that{' '}
            <br data-id="element-126" />
            elevate brands.
          </motion.h1>

          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mt-12" data-id="element-127">
            <a href="#work" className="group flex items-center gap-3 text-lg font-medium border-b border-ink pb-1 hover:text-accent hover:border-accent transition-colors" data-id="element-128">
              Explore Selected Work
              <ArrowDownRight className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform" size={20} data-id="element-129" />
            </a>
            <p className="text-ink-light max-w-sm text-sm sm:ml-8 border-l border-ink/20 pl-6" data-id="element-130">
              Specializing in presentation design, print collateral, and digital
              experiences for forward-thinking companies. Based in California,
              working globally.
            </p>
          </motion.div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="mt-24" data-id="element-131">
        <Marquee data-id="element-132" />
      </motion.div>
    </section>;
}